import { SvgIcon } from '@mui/material';
import {  observer } from 'mobx-react';
import React, { Component } from 'react';
import { IPropsSvgIcone } from '../../modelo/Icone';


class EscaninhoUsuario extends Component {
    render() {
        return (
            <SvgIcon {...this.props} sx={{ width: '32px', height: '32px' }} viewBox="40 0 1600 1600">
                <path fillRule="evenodd" clipRule="evenodd" d="M248 292H1039C1066.61 292 1089 314.386 1089 342V597H991V583C991 555.386 968.614 533 941 533H340C312.386 533 290 555.386 290 583V1037C290 1064.61 312.386 1087 340 1087H649V1192.9C645.593 1193.62 642.093 1194 638.553 1194H248C220.386 1194 198 1171.61 198 1144V342C198 314.386 220.386 292 248 292Z" fill="#9E9E9E" />
                <rect x="344" y="193" width="101" height="105" fill="#9E9E9E" />
                <rect x="842" y="193" width="101" height="105" fill="#9E9E9E" />
                <rect x="395" y="640" width="285" height="103" fill="#9E9E9E" />
                <rect x="395" y="841" width="285" height="103" fill="#9E9E9E" />
                <text x="1000" y="1170" fontFamily="Liberation Sans, Arial, Helvetica, sans-serif" fontSize="600" fontWeight="400" fill="#01579B" textAnchor="middle">U</text>
            </SvgIcon>
        );
    }
}

export default observer(EscaninhoUsuario);
